import { UiRouterTitleProvider } from './ui.router-title.provider';

export function uiRouterTitleConfig( uiRouterTitleProvider: UiRouterTitleProvider ) {
  uiRouterTitleProvider.setDefaultTitle('Automated job search at sea | Global Marine City');
  uiRouterTitleProvider.setTitleToken('$title');
  uiRouterTitleProvider.setSuffix('GMC');
}

uiRouterTitleConfig.$inject = [
  'UiRouterTitleServiceProvider'
];



// WEBPACK FOOTER //
// ./app/shared/directives/ui-router-title/ui-router-title.config.ts